import Genealogy from './genealogy';

export default Genealogy;
